import { createAction, props } from '@ngrx/store';
import { PredictiveSearchResponse } from '../../models/core-apis/predictive-search.interfaces';

enum PredictiveSearchActionTypes {
  loadPredictiveSearchApi = '[flight-shop book widget] load predictive search',
  loadPredictiveSearchApiSuccess = '[flight-shop book widget] load predictive search success',
  loadPredictiveSearchApiFailure = '[flight-shop book widget] load predictive search failure'
}

export const LoadPredictiveSearchApi = createAction(
  PredictiveSearchActionTypes.loadPredictiveSearchApi,
  props<{ predictiveSearchString: string }>()
);

export const LoadPredictiveSearchApiSuccess = createAction(
  PredictiveSearchActionTypes.loadPredictiveSearchApiSuccess,
  props<{
    predictiveSearchResponse: PredictiveSearchResponse;
  }>()
);

export const LoadPredictiveSearchApiFailure = createAction(
  PredictiveSearchActionTypes.loadPredictiveSearchApiFailure
);
